import React, { Component, useContext, useEffect, useState, useRef } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import MobileCartSideBar from "../Components/MobileCartSideBar";
import { ConfigContext } from "../Context/ConfigContext";
import SearchBar from "../Components/SearchBar/SearchBar";
import { useTranslation } from "react-i18next";
import axios from "axios";
import slugify from "slugify";
import {
  RiFacebookBoxFill,
  RiInstagramFill,
  RiTwitterXFill,
} from "react-icons/ri";
import MyGarage from "./MyGarage";
import MobileSearchBar from "../Components/SearchBar/MobileSearchBar";
const Header = ({ openDrawer, isMobile }) => {


  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const dir = localStorage.getItem("dir");
  const {
    setSideBarStatus,
    treeCategories,
    gdcURL,
    setCategories,
    CartItemsQty,
    lang,
    setLang,
    CartAmount,
    GlobleCart,
    categories,
    isCartDropdownOpen,
    setIsCartDropdownOpen
  } = useContext(ConfigContext);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [isFiltersDropdownOpen, setIsFiltersDropdownOpen] = useState(false);
  const [isOilDropdownOpen, setIsOilDropdownOpen] = useState(false);
  const [isBrakesDropdownOpen, setIsBrakesDropdownOpen] = useState(false);

  const [isAccessoriesDropdownOpen, setIsAccessoriesDropdownOpen] = useState(false);
  const [menuItems, setmenuItems] = useState({ paddingLeft: '18px', color: '#FFF', zIndex: '100000' });
  const handleLangChange = (lang) => {
    localStorage.setItem("lang", lang);
    i18n.changeLanguage(lang);
    setLang(lang);
    window.location.reload();
  };
  const toggleDrawer = () => {
    setIsDrawerOpen(!isDrawerOpen);
  };

  useEffect(() => {
    checkCountry();
    var st = dir === "rtl"
      ? { float: "right", marginRight: "20px", color: "#FFF", paddingLeft: '18px !important' }
      : { float: "left", paddingLeft: '18px !important' }
    var mn = menuItems;
    // mn = mn.push(...st);
    setmenuItems(mn)
  }, []);
  const { isUserInternational, setIsUserInternational } =
    useContext(ConfigContext);

  const checkCountry = async () => {
    try {
      // Get IP information from ipinfo.io
      const response = await axios.get(
        "https://ipinfo.io/json?token=c56ea131e1f129"
      ); // Replace 'YOUR_TOKEN' with ipinfo API token
      const data = response.data;

      if (data.country === "AE") {
        setIsUserInternational(false);
      } else {
        setIsUserInternational(true);
      }
    } catch (error) {
      console.error("Error fetching location:", error);
    }
  };
  useEffect(() => {
    fetch(
      `${gdcURL}/Categories/${localStorage.getItem("pc_id") !== null &&
        localStorage.getItem("pc_id") !== "" &&
        localStorage.getItem("pc_id") !== 0
        ? "GetCategoriesByCar"
        : "GetCategories"
      }?pc_id=${localStorage.getItem("pc_id")}&lang=${lang}`
    )
      .then((res) => res.json())
      .then((data) => {
        setCategories(data.data);
      });
  }, [null]);

  const GetSubMenu = ({ childrens }) => {
    if (childrens.length === 0) {
      return null; // No submenu to render
    }

    return (
      <ul className="submenu" style={dir === "rtl" ? { left: "unset", right: "100%" } : { left: "100%" }}>
        {childrens.map((child, index) => (
          <li key={`${child.STR_ID}-${index}`}>
            <NavLink
              to={`/Spare-Parts/${slugify(child.STR_NODE_NAME)}-${child.STR_ID
                }`}>
              {child.STR_NODE_NAME}{" "}
              {child.children.length > 0 && (
                <i
                  style={{ float: dir === "rtl" ? "left" : "right" }}
                  className={`fas ${dir === "rtl" ? "fa-chevron-left" : "fa-chevron-right"
                    }`}></i>
              )}
            </NavLink>
            {child.children.length > 0 && (
              <GetSubMenu childrens={child.children} />
            )}
          </li>
        ))}
      </ul>
    );
  };

  return (
    <header className="header prevent-select" dir={dir} style={{ textAlign: dir === 'rtl' ? 'right' : 'unset' }}>
      <div className="header-top darkColor" style={{ color: "#FFF" }}>
        <div className="container" dir="ltr">
          <div className="header-left d-none d-sm-block"></div>
          {/* End .header-left */}
          <div className="header-dropdowns" dir={dir}>
            <div className="header-dropdown dropdown-expanded d-none d-lg-block">
              <NavLink to="#">{"Links"}</NavLink>
              <div className="header-menu"></div>
              {/* End .header-menu */}
            </div>
            {/* End .header-dropown */}

            <div className="header-dropdown" dir={dir}>
              {lang && lang === "en" ? (
                <NavLink to="#">
                  {" "}
                  <i className="flag-us flag" /> ENG{" "}
                </NavLink>
              ) : (
                <NavLink to="#">
                  {" "}
                  <img
                    src={`${process.env.PUBLIC_URL}/assets/images/Logo/language-6.png`}
                    width={"16px"}
                    height={"16px"}
                    alt="Arabic Flag"
                    style={{ marginLeft: dir === 'rtl' ? '5px' : '' }}
                  />{" "}
                  {t("arabic")}{" "}
                </NavLink>
              )}

              <div className="header-menu" dir={dir}>
                <ul>
                  <li>
                    <NavLink to="#" onClick={() => handleLangChange("en")}>
                      <i className="flag-us flag mr-2" style={{ marginLeft: dir === 'rtl' ? '5px' : '' }} />
                      {t("english")}
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="#" onClick={() => handleLangChange("ar")}>
                      <img
                        src={`${process.env.PUBLIC_URL}/assets/images/Logo/language-6.png`}
                        width={"16px"}
                        height={"16px"}
                        alt="Arabic Flag"
                        style={{ marginLeft: dir === 'rtl' ? '5px' : '' }}
                      />
                      {t("arabic")}
                    </NavLink>
                  </li>
                </ul>
              </div>
              {/* End .header-menu */}
            </div>
            {/* End .header-dropown */}
            <div className="header-dropdown" dir={dir}>
              <NavLink to="#">
                {t(`${localStorage.getItem("currency") ?? "aed"}`)}
              </NavLink>
              <div className="header-menu">
                <ul>
                  <li>
                    <NavLink to="#">
                      <span
                        onClick={() => {
                          localStorage.setItem("currency", "aed");
                          window.location.reload();
                        }}>
                        {t("aed")}
                      </span>
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="#">
                      <span
                        onClick={() => {
                          localStorage.setItem("currency", "usd");
                          window.location.reload();
                        }}>
                        {t("usd")}
                      </span>
                    </NavLink>
                  </li>
                </ul>
              </div>
              {/* End .header-menu */}
            </div>

          </div>
          {/* End .header-right */}
        </div>
        {/* End .container */}
      </div>
      {/* End .header-top */}


      <div className="header-middle lightColor" style={{ borderTop: "0px", display: isMobile ? 'none' : 'block' }}>
        <div className="container">

          <div className="header-left darkColor col-sm-3 w-auto pl-0 pd-1" onClick={() => setSideBarStatus(true)} style={{ cursor: 'pointer' }}>

          </div>
          {/* End .header-left */}

          <div className="header-right w-lg-max">
            <div style={{ direction: dir, width: '530px' }} className="header-icon header-search header-search-inline header-search-category  mt-0">

              <img src={`${process.env.PUBLIC_URL}/assets/images/Logo/car7_transparent_powered_by.png`} style={{ height: '63px', margin: 'auto' }} onClick={() => window.location = '/'} alt="Ghayar Logo" />

            </div>
            {/* End .header-search */}

            <div className="darkColor pl-3 pr-3 pt-1 pb-1"
              style={{ display: "flex", alignItems: "center" }}>

              {isMobile === false && <span className="header-icon" title="Garage" style={{ display: "flex", alignItems: "flex-start", marginRight: "20px", cursor: "pointer", }}  >
                <svg
                  className="header-nav__icon base-svg mr-2"
                  role="img"
                  style={{
                    width: "30px",
                    height: "30px",
                    fill: "rgb(191, 203, 210)",

                  }}>
                  <use href="/assets/images/icon-sprite-bw.svg#sprite-garage-car-icon-bw"></use>
                </svg>
                <div
                  style={{ color: "rgb(191, 203, 210)", marginLeft: '10px', marginTop: '-5px' }}
                  id="dropdownMenuButton"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false">
                  <div style={{ fontSize: "medium", fontWeight: "600", paddingRight: dir === 'rtl' ? '5px' : '', }}>
                    {t("my_cars")}
                  </div>
                  <div style={{ fontSize: "12px", paddingRight: dir === 'rtl' ? '5px' : '' }}>
                    {t("add_your_car")}
                  </div>
                </div>

                <MyGarage />
              </span>}

              {isMobile === false && <span className="header-icon" title="Garage" style={{ display: "flex", alignItems: "flex-start", marginRight: "20px", cursor: "pointer", }}  >
                <i className="icon-user-2" style={{ color: "#bfcbd2" }}></i>
                <div
                  style={{ color: "rgb(191, 203, 210)", marginLeft: '10px' }}
                  onClick={() => {
                    if (localStorage.getItem('customer_id')) {
                      navigate('/MyAccount')
                    } else {
                      window.location = '/login'
                    }

                  }}
                >
                  <div style={{ fontSize: "medium", fontWeight: "600", paddingRight: dir === 'rtl' ? '5px' : '' }}>
                    {t('my_ghayar')}
                  </div>
                  <div style={{ fontSize: "12px", marginTop: "-5px", paddingRight: dir === 'rtl' ? '5px' : '' }}>
                    {localStorage.getItem('customer_id') ? t('my_account') : t('sign_in')}
                  </div>
                </div>
              </span>}


            </div>


            {/* End .dropdown */}
          </div>
          {/* End .header-right */}
        </div>
        {/* End .container */}
      </div>
      <div className="header-middle lightColor" style={{ borderTop: "0px", paddingTop: '12px', paddingBottom: '12px' }}>
        <div className="container">

          <div className="header-left  col-sm-3 w-auto pl-0 pd-1"  style={{ cursor: 'pointer' }}>
            <button
              className="mobile-menu-toggler text-primary mr-2"
              onClick={() => openDrawer()}
              style={{ zIndex: 1000000000 }}

              type="button">
              <i className="fas fa-bars" />
            </button>
            {/* <NavLink to="/" className="logo mt-2 mb-2" style={{maxWidth: '200px'}}>
              
            </NavLink> */}
            <span
              className=""
              onClick={() => setSideBarStatus(true)}
              style={menuItems}
            >
              <label
                style={{
                  color: "rgb(191, 203, 210)",
                  marginTop: '6px',
                  fontWeight: 700,
                  fontSize: "14px",
                }}
                htmlFor="sidebar-toggle"
                className="main-nav navbar-toggler sidebar-toggler"
                aria-expanded="false"
                aria-label="Toggle navigation">
                <svg
                  className="header-nav__icon base-svg mr-2"
                  role="img"
                  style={{
                    width: "25px",
                    height: "25px",
                    fill: "rgb(208, 213, 215)",
                    marginLeft: dir === 'rtl' ? '10px' : ''
                  }}>
                  <use href="/assets/images/icon-sprite-bw.svg#sprite-car-icon-full-bw"></use>
                </svg>
                {t("car_parts")}
                <i className="fas fa-chevron-down ml-2" style={{ fontSize: '12px', position: 'absolute', [dir === 'rtl' ? 'left' : 'right']: '15px', marginTop: '6px' }}></i>
              </label>
            </span>
          </div>
          {/* End .header-left */}

          <div className="header-right w-lg-max">
            <div style={{
              position: 'absolute',
              left: '0',
              right: '0',
              margin: '0 auto',
              width: 'fit-content',
            }}>
              <img src={`${process.env.PUBLIC_URL}/assets/images/Logo/car7_transparent_powered_by.png`} style={{
                height: '28px'
              }} onClick={() => window.location = '/'} alt="Ghayar Logo" />
            </div>
            { isMobile && 
              <div onClick={() => window.location = '/basket'} style={{ marginTop: '10px', marginLeft: dir === 'rtl' ? '10px' : '', position: 'absolute', left: dir === 'rtl'?'12px': '' }}>


                <i className="fas fa-shopping-cart" style={{ color: "#bfcbd2", marginTop: "-3px", fontSize: 'large' }} />
                <span
                  className="cart-count badge-circle"
                  style={dir === 'rtl' ? { marginTop: "-10px", position: 'absolute', right: '-5px' } : { marginTop: "4px", position: 'absolute', left: '12px', top: '-10px' }}>
                  {CartItemsQty}
                </span>
              </div>
            }

            <SearchBar />
            {/* End .header-search */}

            <div className="darkColor pl-3 pr-3 pt-1 pb-1"
              style={{ display: "flex", alignItems: "center" }}

              onMouseEnter={() => setIsCartDropdownOpen(true)}
              onMouseLeave={() => setIsCartDropdownOpen(false)}>

              {/* {isMobile === false && <NavLink to={localStorage.getItem("customer_id") ? "/MyAccount" : "Signup"} className="header-icon" title="login" style={{ marginRight: "20px" }}  >
                <i className="icon-user-2" style={{ color: "#bfcbd2" }}></i>
              </NavLink>} */}
              {isMobile === false && <span className="header-icon" title="Garage" style={{ display: "flex", alignItems: "flex-start", marginRight: "20px", cursor: "pointer", }}  >
                <div style={{ marginTop: '10px', marginLeft: dir === 'rtl' ? '10px' : '', position: 'relative' }}>


                  <i className="fas fa-shopping-cart" style={{ color: "#bfcbd2", marginTop: "-3px" }} />
                  <span
                    className="cart-count badge-circle"
                    style={dir === 'rtl' ? { marginTop: "-10px", position: 'absolute', right: '-5px' } : { marginTop: "4px", position: 'absolute', left: '20px', top: '-10px' }}>
                    {CartItemsQty}
                  </span>
                </div>
                <div
                  style={{ color: "rgb(191, 203, 210)", marginLeft: '10px' }}
                >
                  <div style={{ fontSize: "medium", fontWeight: "600" }}>
                    {t('items')}
                  </div>
                  <div style={{ fontSize: "smaller", marginTop: "-5px" }}>
                    #{localStorage.getItem('session_id')}
                  </div>
                </div>

              </span>}
              {/* <NavLink to="/Cart" title="Cart" style={{ position: "relative", display: "inline-block", marginRight: "20px", }} >
                <i className="minicart-icon" style={{ borderColor: "#bfcbd2", marginTop: "-3px" }} />
                <span
                  className="cart-count badge-circle"
                  style={{ marginTop: "-3px" }}>
                  {CartItemsQty}
                </span>
              </NavLink> */}
              {isMobile === false &&
                <div to="/basket" style={{ position: "relative", display: "inline-block" }} >
                  <div
                    className="mr-3"
                    style={{
                      color: "rgb(229 8 19)",
                      fontSize: "28px",
                      fontFamily: "Montserrat,Arial,sans-serif",
                    }}
                  >
                    {CartAmount} <i className="fas fa-chevron-down" style={{ fontSize: '12px', verticalAlign: 'middle', marginLeft: '5px', color: '#afbac2' }}></i>
                  </div>
                  {isCartDropdownOpen && (
                    <div className="dropdown-content" style={{ position: "absolute", background: "#fff", border: "1px solid #ccc", zIndex: 100000000000, width: '400px', padding: '20px', marginLeft: dir !== 'rtl' ? '-200px' : 'unset', marginRight: dir === 'rtl' ? '-230px' : 'unset' }}>
                      <p>{GlobleCart && GlobleCart.items && GlobleCart.items.map((item) => {
                        return <table style={{ width: '100%' }}>
                          <tr>
                            <td style={{ width: '70px', minWidth: '70px' }} rowSpan={2}><img src={item.item_img_url} style={{ width: '70px', minWidth: '70px' }} alt={item.item_title} /></td>
                            <td style={{ color: '#000', }} className="pl-2 pr-2"><b>{" "} {item.item_title}</b></td>
                          </tr>
                          <tr>
                            <td style={{ color: '#999', width: '200px' }} className="pl-2 pr-2">{" "} {t('qty')} x {item.item_qty}</td>
                            <td>{item.display_price}</td>
                          </tr>
                        </table>
                      })}</p>

                      <hr className="mt-2" style={{ margin: 'unset' }} />
                      <table className="table table-totals mb-0">
                        <tbody>
                          <tr style={{ border: "none", marginBottom: "0px" }}>
                            <td style={{ textAlign: dir === 'rtl' ? 'right' : 'left', }}>{t("sub_total")}</td>
                            <td style={{ textAlign: dir !== 'rtl' ? 'right' : 'left', }} className="custom-dark">
                              <span>{GlobleCart.sub_total_display}</span> <br />
                              <small>{t('price_included_vat_excluded_delivery')}</small>
                            </td>
                          </tr>
                        </tbody>
                      </table>

                      <div className="checkout-methods">
                        <span
                          onClick={() => window.location = "/basket"
                          }
                          className="btn btn-block btn-dark"
                        >
                          {t("proceed_to_checkout")}
                          <i className="fa fa-arrow-right" />
                        </span>
                        <br />

                        <center>

                          <span

                            onClick={() => window.location = `/basket`}

                            className="mt-5" style={{ fontSize: '22px', color: '#003e94', cursor: 'pointer' }}
                          >

                            {t("go_to_basket")}

                          </span>
                        </center>
                      </div>
                    </div>
                  )}
                </div>}


            </div>

            <div className={`dropdown cart-dropdown show`}>
              {/* <div className="cart-overlay" style={SideCartStatus === true?{position: 'fixed'}: {position: 'unset'}}/> */}
              <MobileCartSideBar />
              {/* End .dropdown-menu */}
            </div>
            {/* End .dropdown */}
          </div>
          {/* End .header-right */}
        </div>

        {/* End .container */}
      </div>
      {
        isMobile && <MobileSearchBar />
      }
      {/* End .header-middle */}
      <div
        className="header-bottom  d-none d-lg-block darkColor"
        style={{
          borderBottom: "1px solid rgb(226, 226, 226)",
          marginBottom: "10px",
        }}>
        <div className="container">
          <nav
            className="main-nav w-100"
            style={{ textAlign: dir === "rtl" ? "right" : "left" }}>
            <ul className="menu">
              <li
                className="menuItemStyle"
                style={
                  dir === "rtl"
                    ? { float: "right", marginRight: "20px" }
                    : { float: "left" }
                }
              // onMouseEnter={() => setIsOilDropdownOpen(true)}
              // onMouseLeave={() => setIsOilDropdownOpen(false)}
              >
                <NavLink
                  to="/Spare-Parts/Oil-706233"
                  style={{ color: "#bfcbd2" }}
                >
                  <svg
                    className="header-nav__icon base-svg"
                    role="img"
                    style={{
                      width: "25px",
                      height: "25px",
                      marginTop: '-2px',
                      fill: "rgb(208, 213, 215)",
                      marginLeft: dir === 'rtl' ? '5px' : ''
                    }}
                  >
                    <use href="/assets/images/icon-sprite-bw.svg#sprite-oil-icon-bw"></use>
                  </svg>
                  {t("oil")}
                </NavLink>
                {isOilDropdownOpen && (
                  <ul className="submenu"
                    style={{
                      maxHeight: '350px',
                      overflowY: 'scroll',
                      paddingRight: '15px'
                    }}
                    onMouseEnter={() => setIsAccessoriesDropdownOpen(true)}
                    onMouseLeave={() => setIsAccessoriesDropdownOpen(false)}>


                    <li key={706534} style={{ display: 'flex', alignItems: 'center' }}>
                      <img
                        src={`${gdcURL}/category-images/600x600/706534`}
                        className="img-fluid"
                        alt={t('engine_oil')}
                        style={{ borderRadius: '5px', width: '40px', height: '40px', marginRight: '10px' }}
                        onError={({ currentTarget }) => {
                          currentTarget.onerror = null;
                          currentTarget.src = "https://ghayar.ae/assets/images/prodefault.jpg";
                        }}
                      />
                      <NavLink to={`/Spare-Parts/Engine-Oil-706534`}>
                        {t('engine_oil')}
                      </NavLink>
                    </li>
                  </ul>
                )}

              </li>
              <li
                className="menuItemStyle"
                style={
                  dir === "rtl"
                    ? {
                      float: "right",
                      marginRight: "20px",

                      color: "#FFF",
                      display: "none",
                      marginTop: '-2px',
                      borderLeft: "1px solid #CCC",
                    }
                    : {
                      float: "left",
                      display: "none",
                      marginTop: '-2px',
                      borderLeft: "1px solid #CCC",
                    }
                }>
                <NavLink to="#" style={{ color: "#bfcbd2" }}>
                  <img
                    src="/assets/icons/car-parts.png"
                    className="menuIcon"
                    alt="Batteries"
                    style={{ height: "30px", marginTop: "-8px", marginLeft: dir === 'rtl' ? '5px' : '', }}
                  />
                  {t("car_parts")}
                </NavLink>
                <ul className="submenu">
                  Spare-Parts/Engine-Oil-706534
                  {treeCategories.map((category, index) => (
                    <li key={`${category.STR_ID}-${index}`}>
                      <NavLink to="#">{category.STR_NODE_NAME}</NavLink>
                      <GetSubMenu childrens={category.children} />
                    </li>
                  ))}
                </ul>
              </li>

              <li
                className="menuItemStyle"
                style={
                  dir === "rtl"
                    ? {
                      float: "right",
                      marginRight: "20px",
                      // borderLeft: "1px solid #EEE",
                    }
                    : { float: "left", }
                }>
                <NavLink
                  to="/Spare-Parts/Battery-100042"
                  style={{ color: "#bfcbd2" }}>
                  <svg
                    className="header-nav__icon base-svg"
                    role="img"
                    style={{
                      width: "25px",
                      height: "25px",
                      marginTop: '-2px',
                      fill: "rgb(208, 213, 215)",
                      marginLeft: dir === 'rtl' ? '5px' : '',

                    }}>
                    <use href="/assets/images/icon-sprite-bw.svg#sprite-electrik-icon-bw"></use>
                  </svg>
                  {t("batteries")}
                </NavLink>
              </li>


              {/* <li className="menuItemStyle" style={ dir === "rtl" ? { float: "right", marginRight: "20px" } : { float: "left" } }>
                <NavLink to="/Spare-Parts/Accessories-100733" style={{color: '#bfcbd2'}}><img src="/assets/icons/tools.png" className="menuIcon" alt="Batteries"/>{t("Accessories")}</NavLink>
              </li> */}




              {/* Brakes Menu Item */}
              <li
                className="menuItemStyle"
                style={
                  dir === "rtl"
                    ? { float: "right", marginRight: "20px" }
                    : { float: "left" }
                }
                onMouseEnter={() => {
                  setIsBrakesDropdownOpen(true);
                  setIsFiltersDropdownOpen(false); // Close filters dropdown
                  setIsOilDropdownOpen(false); // Close oil dropdown if open
                }}
                onMouseLeave={() => setIsBrakesDropdownOpen(false)}
              >
                <NavLink
                  to="/Spare-Parts/Braking-System-100006"
                  style={{ color: "#bfcbd2" }}
                >
                  <svg
                    className="header-nav__icon base-svg"
                    role="img"
                    style={{
                      width: "25px",
                      height: "25px",
                      fill: "rgb(208, 213, 215)",
                      marginTop: '-2px',
                      marginLeft: dir === 'rtl' ? '5px' : '',
                    }}
                  >
                    <use href="/assets/images/icon-sprite-bw.svg#sprite-brackes-icon-bw"></use>
                  </svg>
                  {t("brakes")}
                </NavLink>
              </li>
              {/* Filters Menu Item */}
              <li
                className="menuItemStyle"
                style={
                  dir === "rtl"
                    ? { float: "right", marginRight: "20px" }
                    : { float: "left" }
                }
              // onMouseEnter={() => {
              //   setIsFiltersDropdownOpen(true);
              //   setIsBrakesDropdownOpen(false); // Close brakes dropdown
              //   setIsOilDropdownOpen(false); // Close oil dropdown if open
              // }}
              // onMouseLeave={() => setIsFiltersDropdownOpen(false)}
              >
                <NavLink
                  to="/Spare-Parts/Filters-100005"
                  style={{ color: "#bfcbd2" }}
                >
                  <svg
                    className="header-nav__icon base-svg"
                    role="img"
                    style={{
                      width: "25px",
                      height: "25px",
                      fill: "rgb(208, 213, 215)",
                      marginTop: '-2px',
                      marginLeft: dir === 'rtl' ? '5px' : '',
                    }}
                  >
                    <use href="/assets/images/icon-sprite-bw.svg#sprite-filters-icon-bw"></use>
                  </svg>
                  {t("filters")}
                </NavLink>
                {/* {isFiltersDropdownOpen && (
                  <ul className="submenu"
                    style={{
                      maxHeight: '350px',
                      overflowY: 'scroll',
                      paddingRight: '15px'
                    }}
                    onMouseEnter={() => setIsFiltersDropdownOpen(true)}
                    onMouseLeave={() => setIsFiltersDropdownOpen(false)}>
                    {Array.from(new Set(categories.filter(category => category.STR_ID_PARENT === 100005).map(category => category.STR_NODE_NAME))).map((name) => {
                      const category = categories.find(cat => cat.STR_NODE_NAME === name && cat.STR_ID_PARENT === 100005);
                      return (
                        <li key={category.STR_ID} style={{ display: 'flex', alignItems: 'center' }}>
                          <img
                            src={`${gdcURL}/category-images/600x600/${category.STR_ID}`}
                            className="img-fluid"
                            alt={category.STR_NODE_NAME}
                            style={{ borderRadius: '5px', width: '40px', height: '40px', marginRight: '10px' }}
                            onError={({ currentTarget }) => {
                              currentTarget.onerror = null;
                              currentTarget.src = "https://ghayar.ae/assets/images/prodefault.jpg";
                            }}
                          />
                          <NavLink to={`/Spare-Parts/${slugify(category.STR_NODE_NAME)}-${category.STR_ID}`}>
                            {category.STR_NODE_NAME}
                          </NavLink>
                        </li>
                      );
                    })}
                  </ul>
                )} */}


              </li>

              <li
                className="menuItemStyle"
                style={
                  dir === "rtl"
                    ? { float: "right", marginRight: "20px" }
                    : { float: "left" }
                }>
                <NavLink
                  to="/Spare-Parts/Tyre-103100"
                  style={{ color: "#bfcbd2" }}>
                  <svg
                    className="header-nav__icon base-svg"
                    role="img"
                    style={{
                      width: "25px",
                      height: "25px",
                      marginTop: '-2px',
                      fill: "rgb(208, 213, 215)",
                      marginLeft: dir === 'rtl' ? '5px' : '',
                    }}>
                    <use href="/assets/images/icon-sprite-bw.svg#sprite-tyres-icon-bw"></use>
                  </svg>
                  {t("tyres")}
                </NavLink>
              </li>
              <li
                className="menuItemStyle"
                style={
                  dir === "rtl"
                    ? { float: "right", marginRight: "20px" }
                    : { float: "left" }
                }
              // onMouseEnter={() => {
              //   setIsFiltersDropdownOpen(false); // Close filters dropdown
              //   setIsBrakesDropdownOpen(false); // Close brakes dropdown
              //   setIsOilDropdownOpen(false); // Close oil dropdown if open
              //   setIsAccessoriesDropdownOpen(true); // Open accessories dropdown
              // }}
              // onMouseLeave={() => setIsAccessoriesDropdownOpen(false)}
              >
                <NavLink
                  to="Spare-Parts/Accessories-100733"
                  style={{ color: "#bfcbd2" }}
                >
                  <svg
                    className="header-nav__icon base-svg"
                    role="img"
                    style={{
                      width: "25px",
                      height: "25px",
                      marginTop: '-2px',
                      fill: "rgb(208, 213, 215)",
                      marginLeft: dir === 'rtl' ? '5px' : '',
                    }}
                  >
                    <use href="/assets/images/icon-sprite-bw.svg#sprite-misc-icon-bw"></use>
                  </svg>
                  {t("accessories")}
                </NavLink>
                {isAccessoriesDropdownOpen && (
                  <ul className="submenu"
                    style={{
                      maxHeight: '350px',
                      overflowY: 'scroll',
                      paddingRight: '15px'
                    }}
                    onMouseEnter={() => setIsAccessoriesDropdownOpen(true)}
                    onMouseLeave={() => setIsAccessoriesDropdownOpen(false)}>
                    {Array.from(new Set(categories.filter(category => category.STR_ID_PARENT === 100733).map(category => category.STR_NODE_NAME))).map((name) => {
                      const category = categories.find(cat => cat.STR_NODE_NAME === name && cat.STR_ID_PARENT === 100733);
                      return (
                        <li key={category.STR_ID} style={{ display: 'flex', alignItems: 'center' }}>
                          <img
                            src={`${gdcURL}/category-images/600x600/${category.STR_ID}`}
                            className="img-fluid"
                            alt={category.STR_NODE_NAME}
                            style={{ borderRadius: '5px', width: '40px', height: '40px', marginRight: '10px', }}
                            onError={({ currentTarget }) => {
                              currentTarget.onerror = null;
                              currentTarget.src = "https://ghayar.ae/assets/images/prodefault.jpg";
                            }}
                          />
                          <NavLink to={`/Spare-Parts/${slugify(category.STR_NODE_NAME)}-${category.STR_ID}`}>
                            {category.STR_NODE_NAME}
                          </NavLink>
                        </li>
                      );
                    })}
                  </ul>
                )}
              </li>
              <li
                className="menuItemStyle"
                style={
                  dir === "rtl"
                    ? { float: "right", marginRight: "20px" }
                    : { float: "left" }
                }>
                <NavLink
                  to="/Spare-Parts/Tyre-103100"
                  style={{ color: "#bfcbd2" }}>

                  <svg
                    className="header-nav__icon base-svg"
                    role="img"
                    style={{
                      width: "25px",
                      height: "25px",
                      marginTop: '-2px',
                      fill: "rgb(208, 213, 215)",
                      marginLeft: dir === 'rtl' ? '5px' : '',
                    }}
                  >
                    <use href="/assets/images/icon-sprite-bw.svg#sprite-offroad-empty-bw"></use>
                  </svg>
                  {t("offreoad")}
                </NavLink>
              </li>

            </ul>
          </nav>
        </div>
        {/* End .container */}
      </div>

      {/* End .header-bottom */}
    </header>
  );
};

export default Header;
